import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

const marks = [
  {
    value: 0,
    label: '0%',
  },
  {
    value: 10,
    label: '10%',
  },
  {
    value: 20,
    label: '20%',
  },
  {
    value: 30,
    label: '30%',
  },
  {
    value: 40,
    label: '40%',
  },
  {
    value: 50,
    label: '50%',
  },
  {
    value: 60,
    label: '60%',
  },
  {
    value: 70,
    label: '70%',
  },
  {
    value: 80,
    label: '80%',
  },
  {
    value: 90,
    label: '90%',
  },
  {
    value: 100,
    label: '100%',
  }
];

function valuetext(value) {
  return `${value}°C`;
}

function valueLabelFormat(value) {
  return `${value} %`;
}

export default function PercentToDoDone({percentDone, setPercentDone}) {
  const [value, setValue] = React.useState(percentDone);
  const handleChange = (event, newValue) => {
    setPercentDone(newValue);
  };
  
  return (
       <Paper elevation={3} style={{padding: 8}}>
          <Typography id="discrete-slider-custom" variant="h6" gutterBottom>Percent done</Typography>
          <Box sx={{ width: '90%', margin:2 }}>
            <Slider
              width="90%"
              value={percentDone} 
              onChange={handleChange}
              aria-label="Restricted values"
              valueLabelFormat={valueLabelFormat}
              getAriaValueText={valuetext}
              step={null}
              valueLabelDisplay="auto"
              marks={marks}
            /> 
          </Box>
        </Paper>
  );
}